/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminAdvanceTeamBody
 */
export interface AdminAdvanceTeamBody {
    /**
     * The team to advance. Must be one of the match's two participants.
     * @type {string}
     * @memberof AdminAdvanceTeamBody
     */
    teamId: string;
    /**
     * Why the team is being advanced by hand. Recorded on the match and in the audit log.
     * @type {string}
     * @memberof AdminAdvanceTeamBody
     */
    reason: string;
}

/**
 * Check if a given object implements the AdminAdvanceTeamBody interface.
 */
export function instanceOfAdminAdvanceTeamBody(value: object): value is AdminAdvanceTeamBody {
    if (!('teamId' in value) || value['teamId'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function AdminAdvanceTeamBodyFromJSON(json: any): AdminAdvanceTeamBody {
    return AdminAdvanceTeamBodyFromJSONTyped(json, false);
}

export function AdminAdvanceTeamBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminAdvanceTeamBody {
    if (json == null) {
        return json;
    }
    return {
        
        'teamId': json['teamId'],
        'reason': json['reason'],
    };
}

export function AdminAdvanceTeamBodyToJSON(json: any): AdminAdvanceTeamBody {
    return AdminAdvanceTeamBodyToJSONTyped(json, false);
}

export function AdminAdvanceTeamBodyToJSONTyped(value?: AdminAdvanceTeamBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'teamId': value['teamId'],
        'reason': value['reason'],
    };
}

